import axios, { AxiosStatic, AxiosInstance, InternalAxiosRequestConfig } from 'axios';

import { IApiSettings, IExternalAuth, IHttpRequest, IHttpResponseHandler, IStringDictionary } from '../interfaces/IHttp';

class AxiosHttp implements IHttpRequest {

    private service: AxiosInstance;

    public static axiosService: AxiosStatic;

    static getAxios() {
        return AxiosHttp.axiosService || axios;
    }

    constructor(private apiSettings: IApiSettings, private httpResponseHandler: IHttpResponseHandler, private externalAuth: IExternalAuth) {

        const service = AxiosHttp.getAxios().create({
            baseURL: this.apiSettings.apiBaseUrl(),
            headers: {
                "Content-Type": "application/json"
            }
        });

        
        service.interceptors.response.use((value) => {
            if (value.request.responseURL?.includes('/Account/Login?ReturnUrl')) {
                throw new Error('i am error')
            }
            return Promise.resolve(value)
        },
        undefined);
        
        

        this.service = service;
    }

    public get(path: string, options={}) {
        //this needs deleted when npoints are removed and just revert.
        let apiUrl: string;        
        if (path.includes(".thriveplatform.io")) {
            apiUrl = `https://api${path}`;
        } else {
            apiUrl = path;
        }
    
        return this.service.get(apiUrl, options);

        // return this.service.get(path, options);
    }

    public post(path: string, payload: any, options={}) {
        return this.service.post(path, payload, options);
    }
    
    public put(path: string, payload: any, options={}) {
        return this.service.put(path, payload, options);
    }
    
    public delete(path: string, options={}) {
        return this.service.delete(path, options);
    }

    public setHeaders(headers:IStringDictionary){

        this.service.interceptors.request.use((config: InternalAxiosRequestConfig) => {
            
            Object.keys(headers).map((key) => {
                config.headers[key] = headers[key];
            })

            return config;
        });
        
    }

    getCookie(cname) {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for(let c of ca) {
          while (c.startsWith(' ')) {
            c = c.substring(1);
          }
          if (c.startsWith(name)) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }
}

export { AxiosHttp };